import React from "react";
import { Link } from "react-router-dom";
import useNavigateToFibiVoice from "../../../../../hooks/useNavigateToFibiVoice";
import { ArrowRight } from "lucide-react";
import { AiOutlineComment } from "react-icons/ai";

const StartMockBtn = () => {
  const { url } = useNavigateToFibiVoice();
  return (
    <Link
      to={url}
      className="inline-flex items-center gap-4 bg-gradient-to-r from-[#e3bdf7] to-[#A881DB] hover:from-[#EAC5FC]/90 hover:to-[#A881DB]/90 text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 group"
    >
      <AiOutlineComment className="w-6 h-6" />
      {/* <Sparkles className="w-6 h-6" /> */}
      <span>Start Mock Session Now</span>
      <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
    </Link>
  );
};

export default StartMockBtn;
